import { Outlet, useLocation } from "react-router";

import { findNavItem } from "@/app/routes/navigation";
import { Header } from "@/layouts/Header";
import { Sidebar } from "@/layouts/Sidebar";

/**
 * Application shell: fixed sidebar, sticky header, routed content area.
 */
export function AppShell() {
  const { pathname } = useLocation();
  const title = findNavItem(pathname)?.title ?? "";

  return (
    <div className="flex min-h-screen bg-app-canvas">
      <Sidebar />
      {/* min-w-0: without it the column takes its content's min-content width,
          so a wide table widened the page instead of scrolling in its own
          container — and the horizontally scrolled page slid under the fixed
          sidebar. */}
      <div className="ml-[240px] min-w-0 flex-1">
        <Header title={title} />
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
